var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-5"},[_c('HeaderComp'),_c('DeslizaAbajoComp'),_c('PlacesComp'),_c('DestacadosComp'),_c('MethodCompVue'),_c('ConoceComp'),_c('ContactoComp'),_c('NewsletterFormComp')],1)}
var staticRenderFns = []

export { render, staticRenderFns }